
import { BranchModuleDeclaration } from "../branch/branch.declaration";
import { CustomFromDeclaration } from "../custom-form/custom-form.declaration";
import { EmployeeBillingComponent } from "../employeebilling/employeebilling.component";
import { EmpoloyeeBillingDeclatation } from "../employeebilling/employeebilling.declaration";
import { EmployeedetailsComponent } from "../employeedetails/employeedetails.component";
import { EmployeeDetailsDeclatation } from "../employeedetails/employeedetails.declaration";
import { GuestDeclatation } from "../guest/guest.declaration";
import { HolidayComponent } from "../holiday-pattern/holiday.component";
import { NotificationsDeclaration } from "../notifications/notifications.declaration";
import { ParkingModuleDeclaration } from "../parking/parking.declaration";
import { ShiftDeclaration } from "../shift/shfit.declaration";
import { TransportOrganizationComponent } from "./transport-organization.component";

import { EscortComponent } from "../escort/escort.component";
import { EscortDetailsDeclatation } from "../escort/escort.declaration";
import { GlobalSettingsDeclaration } from "../global-settings/global-settings.declaration";
import { LocationDeclaration } from "../location/location.declaration";
import { GeofenceModuleDeclaration } from "../geofence/geofence.declaration";
import { GeoLocationModuleDeclaration } from "../geolocation/geolocation.declaration";
import { ZoneModuleDeclaration } from "../zone/zone.declaration";

export const TransportOrganizationDeclaration = [
    TransportOrganizationComponent,
    EmployeeDetailsDeclatation,
    EmpoloyeeBillingDeclatation,
    
    EmployeedetailsComponent,
    EmployeeBillingComponent,
    GuestDeclatation,
    ShiftDeclaration,
    BranchModuleDeclaration,
    ZoneModuleDeclaration,
    ParkingModuleDeclaration,
    CustomFromDeclaration,
    NotificationsDeclaration,
    HolidayComponent,
    EscortComponent,
    EscortDetailsDeclatation,
    GlobalSettingsDeclaration,
    LocationDeclaration,
    GeofenceModuleDeclaration,
    GeoLocationModuleDeclaration
];
